import React from "react";
import { Button, ClassNameProps, Modal, StyleProps } from "@hex-insights/core";
import { ContractInstallment } from "../../../../Utilities";
import { ControlledContractInstallmentModal } from "../Modal";

export type ContractInstallmentActionButtonsProps = {
	variant: "admin" | "parent";
	contractInstallmentID: ContractInstallment["id"];
} & Partial<ClassNameProps & StyleProps>;

export function ContractInstallmentActionButtons({
	variant,
	contractInstallmentID,
	className,
	style,
}: ContractInstallmentActionButtonsProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<React.Fragment>
			<div className={className} style={style}>
				<Button variant="link" size="small" onClick={openModal}>
					View
				</Button>
			</div>

			<Modal.If condition={isModalOpen}>
				<ControlledContractInstallmentModal
					variant={variant}
					contractInstallmentID={contractInstallmentID}
					onClose={closeModal}
				/>
			</Modal.If>
		</React.Fragment>
	);
}
